import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal, Form } from 'react-bootstrap'
import { Formik, FormikProps } from 'formik'
import ActionData from '../../../types/ActionData'
import { mainColors } from '../../../assets/colors'
import { SubmitSchema } from '../../../utils/validation'
import './index.css'
import { CircularProgress } from '@material-ui/core'

interface Props {
  isCertification: boolean;
  show: boolean;
  state: ActionData;
  submittingApplication: boolean;
  onClose: () => void;
  onSubmit: (values: typeof submitData) => void;
}

const submitData = {
  isCertified: false,
}

const SubmitModal: FC<Props> = ({ isCertification, show, state, submittingApplication, onClose, onSubmit }: Props) => {
  const modalHeaderText = isCertification ? 'Certification Items' : 'Application Items'
  let modalText = ''
  let subModalText = ''
  let mainModalIcon
  const { loading, error, success } = state

  if (success) {
    mainModalIcon = <FontAwesomeIcon icon={['fas', 'check-circle']} color={mainColors.successGreen} className='modal-success-icon' />
    subModalText = 'Success!'
    modalText = `You have submitted your ${modalHeaderText}.`
  }

  if (error) {
    mainModalIcon = <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color={mainColors.loadingBlue} className='modal-success-icon' />
    subModalText = 'Error!'
    modalText = 'Saving Failed!'
  }

  return (
    <Modal size='lg' show={show} onHide={onClose}>
      <Modal.Header closeButton id='model-header'>
        <FontAwesomeIcon icon={['fas', 'check-circle']} size='lg' className='modal-header-icon' />
        <Modal.Title id='modal-header-title'>{modalHeaderText}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          !submittingApplication ? (
            <Formik
              initialValues={submitData}
              enableReinitialize
              onSubmit={(values, { setSubmitting }) => {
                onSubmit(values)
                setSubmitting(false)
              }}
              validationSchema={SubmitSchema}
            >
              {({ errors, values, handleChange, handleSubmit }: FormikProps<typeof submitData>) => (
                <Form noValidate onSubmit={handleSubmit} className='submit-form'>
                  <Form.Check
                    name='isCertified'
                    type='checkbox'
                    label='I certify that the information submitted in this application is true and correct to the best of my knowledge.'
                    checked={values.isCertified || false}
                    onChange={handleChange}
                    isInvalid={!!errors.isCertified}
                    feedback={errors.isCertified}
                    className='submit-form-check'
                  />
                  <div className='modal-button-grp'>
                    <Button variant='secondary' id='modal-cancel-btn' onClick={onClose}>
                      Cancel
                    </Button>
                    <Button
                      type='submit'
                      variant='info'
                      style={{ width: '8rem' }}
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          ) : (
            loading ? (<CircularProgress size={40} />) : (
              <div className='modal-loading-container'>
                {mainModalIcon}
                <span className='modal-success-text'>{subModalText}</span>
                <span className='modal-success-text' style={error !== false ? { width: '100%' } : {}}>
                  {modalText}
                  {
                    error !== false ? (<span style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: error.response.text }} />) : null
                  }
                </span>
                <div className='modal-button-grp' style={{ marginTop: 15 }}>
                  <Button variant='info' className='progress-card-btn' onClick={onClose}>Close</Button>
                </div>
              </div>
            )
          )
        }
      </Modal.Body>
    </Modal>
  )
}

export default SubmitModal